import { useQuery } from 'react-query';
import { defaultStaleTime } from '../withQueryData';
import { usePropertiesApi } from './usePropertiesApi';

export const bankTransferQueryKeys = {
    bankTransfer: (propertyId) => ['bankTransfer', { propertyId }],
};

/**
 * Bank transfer details for a property. Failures resolve to null so a missing
 * config never blocks the reservation page.
 */
export const useBankTransferConfigData = (propertyId) => {
    const { getBankTransferConfig } = usePropertiesApi();

    const queryResults = useQuery({
        queryKey: bankTransferQueryKeys.bankTransfer(propertyId),
        queryFn: async () => {
            try {
                return await getBankTransferConfig(propertyId);
            } catch {
                return null;
            }
        },
        staleTime: defaultStaleTime,
        enabled: !!propertyId,
    });

    return { queryResults };
};
